// Maps OIV7 class names to the labels surveyors will recognise.
// Only entries that differ from the OIV7 name need to be listed here.
export const SURVEY_ITEM_ALIASES: Record<string, string> = {
  'Chest of drawers': 'Dresser',
  'Sofa bed': 'Sofa',
  'Studio couch': 'Sofa',
  Loveseat: 'Loveseat',
  'Kitchen & dining room table': 'Dining Table',
  'Computer monitor': 'Monitor',
  'Infant bed': 'Crib',
  'Stationary bicycle': 'Exercise Bike',
  'Indoor rower': 'Rowing Machine',
  'Microwave oven': 'Microwave',
  'Waste container': 'Trash Can',
  'Luggage and bags': 'Luggage',
  'Musical keyboard': 'Keyboard',
  'Mechanical fan': 'Fan',
  'Home appliance': 'Appliance',
  'Drill (Tool)': 'Drill',
  'Pitcher (Container)': 'Pitcher',
  'Bat (Animal)': 'Bat',
  'Jaguar (Animal)': 'Jaguar',
  'Organ (Musical Instrument)': 'Organ',
  'Nail (Construction)': 'Nail',
  Lamp: 'Lamp, Floor/Pole',
};
